class ProductDetailStock extends Component {
    constructor(el) {
        super(el);
        this.stockHolder = this.$find('[data-stock-placeholder]');
        EventBus.getInstance().addEventListener('productVariantChanged', e => this.onVariantChange(e.detail));
    }

    onVariantChange(variant) {
        if (variant.availability) {
            this.stockHolder.innerText = variant.availability;
        }

        this.stockHolder.classList.remove('is-in', 'is-out', 'is-inquirable');

        if (variant.availabilityCssClass) {
            this.stockHolder.classList.add(variant.availabilityCssClass);
        }
    }
}
